import {
    Swiper,
	Pagination,
	Navigation,
    EffectFade,
    Autoplay
} from 'swiper/js/swiper.esm.js';
import 'swiper/swiper.scss';

Swiper.use([Navigation, Pagination, EffectFade, Autoplay]);

const contentSlider = new Swiper('.content-slider', {
    speed: 600,
    spaceBetween: 30,
    slidesPerView: 1,
    loop: true,
    autoHeight: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
});

const heroSlider = new Swiper('.hero-slider', {
    speed: 600,
    spaceBetween: 0,
    slidesPerView: 1,
    loop: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
});

const presentationSlider = new Swiper('.presentation-slider', {
    autoplay: {
        delay: 4000,
    },
    speed: 900,
    slidesPerView: 1,
	loop: true,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	}
});